export default "__VITE_ASSET__DqWzV9Gh__"